import { api } from './client';

export interface AiModelInfo {
  id: string;
  name: string;
  provider: string;
  contextWindow: number;
  maxOutputTokens: number;
  supportsTools: boolean;
  supportsThinking: boolean;
  speedTier: string;
  costTier: number;
  description: string;
  isDefault: boolean;
  isGlobalDefault: boolean;
}

export const modelsApi = {
  /** Get all available AI models */
  getAll: () => api.get<AiModelInfo[]>('/api/models'),

  /** Get models by provider */
  getByProvider: (provider: string) =>
    api.get<AiModelInfo[]>(`/api/models/by-provider/${provider}`),

  /** Get a specific model by ID */
  getById: (modelId: string) =>
    api.get<AiModelInfo>(`/api/models/${modelId}`),

  /** Get the default model for a provider */
  getDefault: (provider: string) =>
    api.get<AiModelInfo>(`/api/models/default/${provider}`),

  /** Get the global default model (typically DeepSeek) */
  getGlobalDefault: () =>
    api.get<AiModelInfo>('/api/models/global-default'),
};
